var map = {
	"./ar/photo/PhotoPage.vue": [
		5460,
		5460
	],
	"./bn/photo/PhotoPage.vue": [
		4290,
		4290
	],
	"./en/photo/PhotoPage.vue": [
		9154,
		9154
	],
	"./fa/photo/PhotoPage.vue": [
		5788,
		5788
	],
	"./ur/photo/PhotoPage.vue": [
		2907,
		2907
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8042;
module.exports = webpackAsyncContext;